/**
 * @description Retrieves the options for the access required dropdowns used by each personnel's settings
 */

import { useQuery } from '@tanstack/react-query';

import processOrderedDropdownOptions from '../utils/processOrderedDropdownOptions';
import fetchDropdownOptions from '../utils/fetchDropdownOptions';

const fetchAccessRequiredList = fetchDropdownOptions(
  'personnel.clearance.indoctrinationLevel',
  'access required'
);

const useContractPersonnel = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['useContractPersonnel'],
    queryFn: fetchAccessRequiredList,
    select: processOrderedDropdownOptions,
    refetchOnWindowFocus: false,
    staleTime: Infinity
  });

  return {
    data,
    isError,
    isLoading
  };
}

export default useContractPersonnel;
